import { createAsyncThunk } from '@reduxjs/toolkit';
import { IPublicCreditCard } from '@wix/cashier-core/dist/src/services/CreditCard/types';
import { cardAPI } from '../utils/api/cardAPI';

export const ERROR_FETCH_CARD_LIST = 'ERROR_FETCH_CARD_LIST';
export const deletePrimaryCard = createAsyncThunk<IPublicCreditCard[], 'DELETE_PRIMARY_CARD'>(
  'DELETE_PRIMARY_CARD',
  (creditCardId: string, thunkApi) => {
    return cardAPI
      .deleteCard(creditCardId)
      .then(() => cardAPI.fetchCards().catch((_) => thunkApi.rejectWithValue(new Error(ERROR_FETCH_CARD_LIST))));
  },
);
